import { Box, Text, Title } from "@mantine/core";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import React from "react";
import classes from "./stat-card.module.css";

const BURST_SAMPLE_SIZE = 4;

interface StatCardProps {
  BackgroundIcon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & {
    muiName: string;
  };
  value: string;
  description: string;
  hoverIcons?: React.ReactNode[];
}

export default function StatCard({
  BackgroundIcon,
  value,
  description,
  hoverIcons,
}: StatCardProps) {
  const icons =
    hoverIcons && hoverIcons.length > 0
      ? Array.from(
          { length: Math.min(BURST_SAMPLE_SIZE, hoverIcons.length) },
          (_, i) => hoverIcons[i % hoverIcons.length]
        )
      : null;

  return (
    <Box className={classes.cardWrapper}>
      {icons && (
        <Box className={classes.burst} aria-hidden>
          <Box className={classes.burstRow} data-position="top">
            {icons.map((hoverIcon, i) => (
              <Box key={`top-${i}`} className={classes.burstIcon}>
                <Box className={classes.burstIconInner}>{hoverIcon}</Box>
              </Box>
            ))}
          </Box>
          <Box className={classes.burstRow} data-position="bottom">
            {[...icons].reverse().map((hoverIcon, i) => (
              <Box key={`bottom-${i}`} className={classes.burstIcon}>
                <Box className={classes.burstIconInner}>{hoverIcon}</Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
      <Box className={classes.card}>
        <Box className={classes.bgIcon} aria-hidden>
          <BackgroundIcon />
        </Box>
        <Title order={2} className={classes.value}>
          {value}
        </Title>
        <Text className={classes.description}>{description}</Text>
      </Box>
    </Box>
  );
}
